import { from } from "rxjs";
import { filter, retry, switchMap } from "rxjs/operators";
import { filterNewQuests } from "../../../selectors/selectQuestInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { actionQuestInfo, actionQuestInfoAddNewQuestIds, TypeActionQuestInfo, } from "./actionQuestInfo";
import { actionQuestOpen, actionQuestUpdate } from "./list/actionQuests";
export var epicQuestInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionAuth.Login || action.type === TypeActionQuestInfo.Request;
    }), switchMap(function (action) {
        var playerId = action.type === TypeActionAuth.Login
            ? action.playerId
            : state$.value.playerInfo.playerId;
        return deps
            .netSend({
            id: CommandCode.QuestInfo,
            props: {
                playerId: playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            var shouldAddNewQuests = action.type !== TypeActionAuth.Login;
            var openQuestActions = res.quest
                .filter(function (value) {
                return !value.state;
            })
                .map(function (value) {
                return actionQuestOpen(value.questId, [value.questId]);
            });
            var actions = [actionQuestInfo(res)].concat(openQuestActions);
            if (openQuestActions.length > 0) {
                actions.push(actionQuestUpdate(openQuestActions[openQuestActions.length - 1].questIds || []));
            }
            if (shouldAddNewQuests) {
                var newQuestIds = filterNewQuests(state$.value, res.quest).newQuestIds;
                actions.push(actionQuestInfoAddNewQuestIds(newQuestIds));
            }
            return from(actions);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epicQuestInfo.ts
// module id = 1964
// module chunks = 3